/**
 * Size Memory
 * ------------------------------------------------------------------
 * Remembers the last Size the shopper picked and automatically re-selects 
 * that same size — IF it's in stock — when they land on a different product.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "muffynn:preferredSize";

  function getStoredSize() {
    try { return sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function setStoredSize(value) {
    try { sessionStorage.setItem(STORAGE_KEY, value); } catch (e) {}
  }

  function getOptionContainer(control) {
    return control.closest(".product-form__option-selector") || control.closest(".select-wrapper") || null;
  }

  function getOptionNameText(container) {
    if (!container) return "";
    var nameEl = container.querySelector(".product-form__option-name, .combo-box__title");
    return nameEl ? nameEl.textContent.trim() : "";
  }

  function isSizeOption(control) {
    var container = getOptionContainer(control);
    return /size/i.test(getOptionNameText(container));
  }

  function isUnavailable(el) {
    return !!el.closest(".is-disabled");
  }

  function readLabelFor(control) {
    if (control.tagName === "SELECT") {
      var opt = control.options[control.selectedIndex];
      return opt ? opt.textContent.trim() : "";
    }
    var container = getOptionContainer(control);
    if (control.id) {
      var label = container && container.querySelector('label[for="' + control.id + '"]');
      if (label) return label.textContent.trim();
    }
    if (container) {
      var selectedOpt = container.querySelector('[role="option"][aria-selected="true"]');
      if (selectedOpt) return selectedOpt.textContent.trim();
    }
    return "";
  }

  document.addEventListener("change", function (event) {
    var control = event.target;
    if (!control.matches || !control.matches('input[data-option-position], select[data-option-position]')) return;
    if (!isSizeOption(control)) return;
    var label = readLabelFor(control);
    if (label) setStoredSize(label);
  }, true);

  function triggerChangeEvents(element) {
    // 1. Force the value adjustment signal on input controls
    element.dispatchEvent(new Event("change", { bubbles: true }));

    // 2. Alert the color picker component right away to filter the options
    document.dispatchEvent(new CustomEvent("size-memory:applied", { 
      detail: { size: getStoredSize() } 
    }));
    
    // 3. Fire a physical click to sync the theme's core engine
    var clickEvent = new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window
    });
    element.dispatchEvent(clickEvent);
  }

  function applyToContainer(container) {
    var preferred = getStoredSize();
    if (!preferred || !isSizeOption(container.querySelector("[data-option-position]") || container)) return;

    // 1) Radio-based selectors
    var radios = container.querySelectorAll('input[type="radio"][data-option-position]');
    if (radios.length) {
      var matchRadio = null;
      radios.forEach(function (radio) {
        var label = container.querySelector('label[for="' + radio.id + '"]');
        var text = label ? label.textContent.trim() : "";
        if (text.toLowerCase() === preferred.toLowerCase()) matchRadio = radio;
      });
      if (matchRadio && !matchRadio.checked && !isUnavailable(matchRadio)) {
        matchRadio.checked = true;
        triggerChangeEvents(matchRadio);
      }
      return;
    }

    // 2) Plain <select>
    var select = container.querySelector("select[data-option-position]");
    if (select) {
      var matchOption = null;
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.textContent.trim().toLowerCase() === preferred.toLowerCase() && !opt.disabled) matchOption = opt;
      });
      if (matchOption && select.value !== matchOption.value) {
        select.value = matchOption.value;
        triggerChangeEvents(select);
      }
      return;
    }

    // 3) combo-box "dropdown" selector
    var options = container.querySelectorAll('[role="option"]');
    if (options.length) {
      var matchButton = null;
      options.forEach(function (opt) {
        if (opt.tagName === "A") return;
        if (opt.textContent.trim().toLowerCase() === preferred.toLowerCase()) matchButton = opt;
      });
      if (matchButton && matchButton.getAttribute("aria-selected") !== "true" && !isUnavailable(matchButton)) {
        matchButton.click();
        document.dispatchEvent(new CustomEvent("size-memory:applied", { detail: { size: preferred } }));
      }
    }
  }

  function applySizePreference(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll(".product-form__option-selector, .select-wrapper");
    containers.forEach(applyToContainer);
  }

  document.addEventListener("DOMContentLoaded", function () { applySizePreference(document); });
  document.addEventListener("shopify:section:load", function (event) { applySizePreference(event.target); });
  document.addEventListener("openable-element:load:end", function (event) { applySizePreference(event.target); }, true);
})();